function NotificationsBadge({
  length,
  relativeClassNames="",
  parentClassNames = "",
  childClassNames = "",
  xAxis = "right",
  position = "absolute"
}: {
  length: number;
  relativeClassNames?: string;
  parentClassNames?: string;
  childClassNames?: string;
  xAxis?: "right" | "left" | "start" | "end";
  position?: "absolute" | "relative";
}) {
  // Absolute positioning version (for overlays)
  if (position === "absolute") {
    return (
      <>
        <span
          className={`absolute ${xAxis}-[2px] top-[2px] inline-flex h-4 w-4 animate-ping items-center justify-center rounded-full opacity-75 md:${xAxis}-0 md:top-0 ${parentClassNames}`}
        />
        <span
          className={`absolute ${xAxis}-[2px] top-[2px] inline-flex h-4 w-4 items-center justify-center rounded-full text-xs font-medium text-white md:${xAxis}-0 md:top-0 ${childClassNames}`}
        >
          {length}
        </span>
      </>
    );
  }

  // Relative positioning version (for flex containers)
  return (
    <div className={`relative inline-flex h-5 w-5 ${relativeClassNames}`} >
      <span
        className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 ${parentClassNames}`}
      />
      <span
        className={`relative inline-flex h-5 w-5 items-center justify-center rounded-full text-xs font-medium text-white ${childClassNames}`}
      >
        {length}
      </span>
    </div>
  );
}

export default NotificationsBadge;